/* eslint-disable import/prefer-default-export */
import styled from 'styled-components';
import { breakpoints } from '@bnnvara/breakpoints';
import * as S from '../common/styled';

export const Video = styled.video`
  background: #000;
  width: 100%;
  height: 100%;
`;

export const TopIcons = styled.div`
  position: absolute;
  z-index: 99;
  right: 12px;
  top: 10px;
  display: flex;
  align-items: center;

  > a,
  > button {
    margin-left: 8px;

    ${breakpoints.md} {
      margin-left: 12px;
    }
  }

  ${breakpoints.md} {
    top: 22px;
    right: 25px;
  }
`;

export const ShareToggleButton = styled.button`
  ${S.BaseButton}
`;
